<template>
  <div
    class="uk-position-relative uk-visible-toggle rwd"
    tabindex="-1"
    uk-slideshow="autoplay: true;autoplay-interval: 6000;"
  >
    <ul class="uk-slideshow-items">
      <li class="slideshow-items" v-for="item in data" :key="item.pageId">
        <router-link
          :to="{ name: justify, params: { pageId: item.pageId } }"
          style="display: block"
          class="a_link"
          title="國際趨勢文章"
        >
          <p class="phone_title" :style="{ fontSize: fontSize.p + 'em' }">
            {{ item.type }}
          </p>
          <div v-if="item.video" class="video">
            <div class="iframe">
              <div v-html="item.video" />
            </div>
          </div>
          <div v-else class="pic">
            <img :src="item.image" alt="國際趨勢圖片" />
          </div>
          <div class="txt_area">
            <p
              style="text-align: left; padding: 5px 10px"
              class="message"
              :style="{ fontSize: fontSize.p + 'em' }"
            >
              {{ item.title }}
            </p>
          </div>
        </router-link>
      </li>
    </ul>
    <a
      title="輪播左邊按鈕"
      class="uk-position-center-left uk-position-small"
      href="#"
      uk-slidenav-previous
      uk-slideshow-item="previous"
    >
      <span class="forFreeGo">&nbsp;</span>
    </a>
    <a
      title="輪播右邊按鈕"
      class="uk-position-center-right uk-position-small"
      href="#"
      uk-slidenav-next
      uk-slideshow-item="next"
    >
      <span class="forFreeGo">&nbsp;</span>
    </a>
  </div>
</template>

<script>
import { defineComponent, inject } from "vue";
export default defineComponent({
  name: "Carousel",
  props: {
    data: {
      type: Array,
      required: true,
    },
    justify: {
      type: String,
      required: true,
    },
  },
  setup() {
    let fontSize = inject("fontSize");
    return {
      fontSize,
    };
  },
});
</script>

<style lang="scss" scoped>
img {
  object-fit: cover;
  width: 100%;
}
.a_link {
  aspect-ratio: 16 / 9;
  width: 100%;
  p {
    color: $black_color;
  }
}
.uk-position-relative {
  padding-bottom: 80px;
  a {
    margin: 0;
  }
}
</style>
